import RadioGroup from 'components/elements/molecules/Radio/RadioGroup';
import RadioOption from 'components/elements/molecules/Radio/RadioOption';

export default function CourseList({
  loading,
  courses,
  selectedCourse,
  onSelect,
}) {
  if (loading)
    return (
      <div
        className="fa fa-spin fa-spinner text-primary spinner"
        style={{ fontSize: '16px' }}
      />
    );

  return (
    <div>
      <RadioGroup
        handleChange={(event) => {
          const course = courses.find(
            (i) => i.googleCourseId === event.target.value,
          );
          onSelect(course);
        }}
      >
        <div className="d-flex filter-group">
          {courses.map((course, i) => (
            <div className="d-flex align-items-center mr-2">
              <RadioOption
                id={`${course.googleCourseId}-${i}`}
                name={course.googleCourseId}
                value={course.googleCourseId}
                label={course.name}
                checked={
                  selectedCourse?.googleCourseId === course.googleCourseId
                }
              />
            </div>
          ))}
        </div>
      </RadioGroup>
    </div>
  );
}
